import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/projects/SampleProjectsClientPage.jsx");
